import React, {useEffect, useState} from 'react'
import './Stock.scss'
import {useLocation, useParams} from 'react-router-dom';
import StocksChat from "../../containers/StocksChat/StocksChat";
import {Auth} from "../../utils/Auth";
import {getStock} from "../../request/RequestMarket";
import utils from "../../utils/utils.json"
import CustomImage from "../../components/CustomImage/CustomImage";
import {formatCurrency, getStockLogo, percentageDiff, timestampToDDMMYY, timestampToHHMM, formatPrice} from "../../utils/services";
import {useTranslation} from 'react-i18next';
import LineChart from "../../components/Charts/LineChart/LineChart";
import TransactionWidget from "../../containers/TransactionWidget/TransactionWidget";
import Spinner from "../../components/Spinner/Spinner";
import constants from "../../utils/constants.js"
import {RequestWallet} from "../../request/RequestWallet";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {Divider} from "@mui/material";
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';

function Stock() {
    const requestWallet = new RequestWallet();
    const {t} = useTranslation();
    const {ticker} = useParams();
    const [username, setUsername] = useState(null);
    const [data, setData] = useState(null);
    const ONE_DAY = utils.rangeHistoryStock.ONE_DAY
    const ONE_YEAR = utils.rangeHistoryStock.ONE_YEAR
    const [range, setRange] = useState(ONE_YEAR[0]);
    const [history, setHistory] = useState([])
    const [timeStamp, setTimeStamp] = useState([])
    const [performance, setPerformance] = useState(0);
    const [isLoading, setIsLoading] = useState(true)
    const [isChartLoading, setIsChartLoading] = useState(false)
    const [isFav, setFav] = useState(false)
    const auth = new Auth();
    const location = useLocation();

    async function fetchWalletFav() {
        if (auth.isLoggedIn()) {
            const result_wallet = await requestWallet.getWallet();
            if (result_wallet.data && result_wallet.data.favoris.length > 0) {
                const favsTickers = result_wallet.data.favoris.map(stock => stock.ticker)
                setFav(favsTickers.includes(ticker))
            } else {
                setFav(false)
            }
        }
    }

    async function fetchStockData() {
        const result = await getStock(ticker, range);
        setData(result.data)
        if (result.data) {
            if (result.data.history.chart.result[0].timestamp !== undefined && result.data.history.chart.result[0].indicators.quote[0].high !== undefined) {
                if (range === ONE_DAY[0]) {
                    setTimeStamp(timestampToHHMM(result.data.history.chart.result[0].timestamp))
                } else {
                    setTimeStamp(timestampToDDMMYY(result.data.history.chart.result[0].timestamp))
                }
                setHistory(result.data.history.chart.result[0].indicators.quote[0].high)
            }
            setIsLoading(false)
            setIsChartLoading(false)
        }
    }

    useEffect(() => {
        setIsLoading(true);
        setData(null);
        fetchWalletFav();

        async function fetchUsername() {
            const auth = new Auth();
            const name = await auth.getUsername();
            await setUsername(name);
        }

        fetchUsername();
    }, [ticker]);

    useEffect(() => {
        fetchStockData();
    }, [range, ticker]);


    useEffect(() => {
        setPerformance(percentageDiff(history[0], history[history.length - 1]))
    }, [history, range, location]);


    const handleChangeRange = (newRange) => {
        if (newRange !== range) {
            setIsChartLoading(true);
            setRange(newRange);
        }
    }

    async function manageFav() {
        const previousFav = isFav;
        setFav(!isFav);
        try {
            if (previousFav) {
                await requestWallet.delFavori(ticker)
            } else {
                await requestWallet.addFavori(ticker)
            }
        } catch (error) {
            setFav(previousFav);
        }
    }


    return (
        <div className='containerPage'>
            {
                isLoading ?
                    <div className={"pageStock"}>
                        <div className="d-flex w-100 containerSections">
                            <div className="containerStockGraph d-flex flex-column">
                                <div className="leftSide w-100 premium-card d-flex flex-column mb-4" style={{height: '560px'}}>
                                    <div className="d-flex align-center stock-header mb-3">
                                        <div className="skeleton" style={{width: 50, height: 50, borderRadius: 12}}></div>
                                        <div className="skeleton ml-3" style={{width: 250, height: 40}}></div>
                                        <div className="skeleton ml-3" style={{width: 60, height: 25}}></div>
                                    </div>
                                    <div className="d-flex w-100 flex-grow-1 flex-column">
                                        <div className="d-flex justify-between align-center mb-3">
                                            <div className="d-flex align-center w-100">
                                                <div className="skeleton" style={{width: 150, height: 40}}></div>
                                                <div className="skeleton ml-3" style={{width: 80, height: 30, borderRadius: 8}}></div>
                                            </div>
                                        </div>
                                        <div className="skeleton w-100" style={{height: 350, borderRadius: 12}}></div>
                                    </div>
                                </div>
                                <div className="stock-info premium-card mb-4">
                                    <div className="skeleton w-100" style={{height: 150, borderRadius: 12}}></div>
                                </div>
                            </div>
                            <div className="transaction-widget">
                                <div className="premium-card" style={{padding: '24px'}}>
                                    <div className="skeleton w-100 mb-3" style={{height: 40, borderRadius: 20}}></div>
                                    <div className="skeleton mb-4 mx-auto" style={{height: 20, width: '60%'}}></div>
                                    <div className="d-flex mb-4" style={{gap: '8px'}}>
                                       <div className="skeleton" style={{flex: 1, height: 35, borderRadius: 12}}></div>
                                       <div className="skeleton" style={{flex: 1, height: 35, borderRadius: 12}}></div>
                                       <div className="skeleton" style={{flex: 1, height: 35, borderRadius: 12}}></div>
                                    </div>
                                    <div className="skeleton w-100 mb-4" style={{height: 60, borderRadius: 12}}></div>
                                    <div className="skeleton w-100 mb-4" style={{height: 60, borderRadius: 12}}></div>
                                    <div className="skeleton w-100 mt-5" style={{height: 50, borderRadius: 12}}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={"pageStock"}>
                        <div className="d-flex w-100 containerSections">
                            <div className={"containerStockGraph d-flex flex-column"}>
                                <div className="leftSide w-100 premium-card d-flex flex-column mb-4" style={{minHeight: '560px'}}>
                                    <div className={"d-flex align-center stock-header mb-3"}>
                                        <CustomImage src={getStockLogo(ticker)} alt={"Stock logo"} className={"stock-image"}/>
                                        <div className="d-flex align-center w-100" style={{ minWidth: 0 }}>
                                            <h1 className="name">{data?.name || ticker}</h1>
                                            {(data?.name && data?.name !== ticker) && (
                                                <span className="ml-3 ticker-badge">{ticker}</span>
                                            )}
                                        </div>
                                        {auth.isLoggedIn() &&
                                            <div className="ml-3 mt-1">
                                                <span onClick={manageFav} 
                                                      className={`favorite-icon ${isFav ? 'active' : ''}`} 
                                                      style={{ cursor: 'pointer', color: isFav ? '#f59e0b' : '#94a3b8', transition: 'all 0.2s ease', display: 'flex' }}>
                                                    {isFav ? <StarRoundedIcon fontSize="large" /> : <StarOutlineRoundedIcon fontSize="large" />}
                                                </span>
                                            </div>
                                        }
                                    </div>
                                    
                                    <div className="d-flex w-100 flex-grow-1 flex-column">
                                        <div className="d-flex justify-between align-center headerLineChart mb-3">
                                            <div className="d-flex align-center w-100">
                                                <h1 className="stock-price" style={{ margin: 0 }}> {`${formatPrice(data?.price)} ${data?.currency}`}</h1>
                                                <h3 className="ml-3" style={{ margin: 0, display: "flex", marginLeft: '15px' }}>
                                                    {(() => {
                                                        const colorPrice = performance[0] >= 0 ? constants.green : constants.red;
                                                        const backgroundColor = colorPrice.includes('rgb') 
                                                            ? colorPrice.replace('rgb', 'rgba').replace(')', ', 0.1)') 
                                                            : colorPrice + "1A";
                                                        return (
                                                            <span className="gain-loss-pill" style={{ color: colorPrice, backgroundColor }}>
                                                                {performance[1]}
                                                            </span>
                                                        );
                                                    })()}
                                                </h3>
                                            </div>
                                            <div className="justify-end d-flex w-50">
                                                <div onClick={() => handleChangeRange(ONE_DAY[0])}
                                                     className={range === ONE_DAY[0] ? "focus boxRange mr-2" : "boxRange mr-2"}> {ONE_DAY[1]} </div>
                                                <div onClick={() => handleChangeRange(ONE_YEAR[0])}
                                                     className={range === ONE_YEAR[0] ? "focus boxRange" : "" + ` boxRange`}> {ONE_YEAR[1]} </div>
                                            </div>
                                        </div>

                                        <div className="mb-5 containerLineChart w-100 mt-6" style={{ opacity: isChartLoading ? 0.4 : 1, transition: 'opacity 0.2s ease-in-out' }}>
                                            <LineChart
                                                className={"stock-graph"}
                                                data={history}
                                                labels={timeStamp}
                                                lineColor={performance[0] > 0 ? constants.green : constants.red}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className={"stock-info premium-card mb-4"}>
                                    <h2 className={"mb-3"}> {t('stock.about')} {data?.name} </h2>
                                    
                                    {(!data?.marketCap && !data?.exchange && !data?.ceo && !data?.website && !data?.description) ? (
                                        <p className="text-gray" style={{ fontStyle: 'italic' }}>Aucune information disponible pour cette entreprise.</p>
                                    ) : (
                                        <>
                                            <div className="stock-stats-grid mb-4">
                                                {data?.marketCap && (
                                                    <div className="stat-pill">
                                                        <span className="stat-label">{t('stock.marketCap')}</span>
                                                        <span className="stat-value">{`${formatCurrency(data?.marketCap)} ${data?.currency}`}</span>
                                                    </div>
                                                )}
                                                {data?.exchange && (
                                                    <div className="stat-pill">
                                                        <span className="stat-label">{t('stock.exchange')}</span>
                                                        <span className="stat-value">{data?.exchange}</span>
                                                    </div>
                                                )}
                                                {data?.ticker && (
                                                    <div className="stat-pill">
                                                        <span className="stat-label">{t('stock.ticker')}</span>
                                                        <span className="stat-value">{data?.ticker}</span>
                                                    </div>
                                                )}
                                                {data?.ceo && (
                                                    <div className="stat-pill">
                                                        <span className="stat-label">{t('stock.ceo')}</span>
                                                        <span className="stat-value">{data?.ceo}</span>
                                                    </div>
                                                )}
                                                {data?.website && (
                                                    <div className="stat-pill">
                                                        <span className="stat-label">{t('stock.website')}</span>
                                                        <a href={data?.website} target="_blank" rel="noopener noreferrer" className="stat-value link">
                                                            {data?.website.replace(/^https?:\/\/(www\.)?/, '')}
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                            
                                            {data?.description &&
                                                <div className="stockDescription w-100 mt-4 text-justify" style={{ color: '#64748b', lineHeight: '1.6', fontSize: '1.05rem' }}>
                                                    {data?.description}
                                                </div>
                                            }
                                        </>
                                    )}
                                </div>
                                
                                <div className="premium-card stock-chat-card">
                                    <StocksChat stocks={ticker}/>
                                </div>
                            </div>

                            <div className="transaction-widget">
                                <div className="premium-card" style={{maxHeight: 'calc(100vh - 120px)', overflowY: 'auto', scrollbarWidth: 'none'}}>
                                    <TransactionWidget price={data?.price} ticker={ticker}/>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default Stock;